module.exports = __webpack_public_path__ + "img/nbttsc.a9230dd6.png";